import React from 'react'

export interface DivinationFeatureEntryProps {
  featureName: string
  title: string
  description: string
  buttonText: string
  buttonState: 'filled' | 'outlined'
  onClick: () => void
  style?: React.CSSProperties
}

export const DivinationFeatureEntry: React.FC<DivinationFeatureEntryProps> = ({
  featureName,
  title,
  description,
  buttonText,
  buttonState,
  onClick,
  style,
}) => (
  <div className={`divination-feature-entry divination-feature-entry--${featureName}`} style={style}>
    <div className="divination-feature-entry__cards">
      <div className="divination-feature-entry__card divination-feature-entry__card--left" />
      <div className="divination-feature-entry__card divination-feature-entry__card--center" />
      <div className="divination-feature-entry__card divination-feature-entry__card--right" />
    </div>
    <div className="divination-feature-entry__content">
      <div className="divination-feature-entry__header">
        <span className="divination-feature-entry__name">{title}</span>
        <button
          type="button"
          className={`divination-feature-entry__button divination-feature-entry__button--${buttonState}`}
          onClick={() => onClick()}
        >
          {buttonText}
        </button>
      </div>
      <p className="divination-feature-entry__description">{description}</p>
    </div>
  </div>
)
